export const businessDivisions = [
  {
    id: "trading",
    title: "Trading",
    description: "Supplying quality products from trusted local and international manufacturers to meet diverse industry requirements.",
    icon: "ri-swap-box-line",
    href: "/trading",
    image: "https://readdy.ai/api/search-image?query=Modern%20international%20trade%20and%20shipping%20container%20port%20with%20cargo%20ships%2C%20industrial%20logistics%20terminal%2C%20professional%20corporate%20atmosphere%2C%20clean%20minimalist%20composition%2C%20warm%20golden%20sunset%20lighting%2C%20cinematic%20depth%20of%20field%2C%20luxurious%20editorial%20photography%20style&width=800&height=600&seq=trading-01&orientation=landscape",
  },
  {
    id: "procurement",
    title: "Procurement",
    description: "Strategic sourcing solutions that ensure quality, value for money, and reliable supplier partnerships.",
    icon: "ri-shopping-bag-3-line",
    href: "/procurement",
    image: "https://readdy.ai/api/search-image?query=Professional%20procurement%20and%20sourcing%20office%20with%20product%20samples%20on%20modern%20desk%2C%20quality%20inspection%20tools%2C%20clean%20corporate%20environment%2C%20warm%20natural%20light%2C%20minimalist%20aesthetic%2C%20premium%20business%20photography%20with%20shallow%20depth%20of%20field&width=800&height=600&seq=procure-01&orientation=landscape",
  },
  {
    id: "logistics",
    title: "Supply Chain Management",
    description: "Planning, coordinating, and optimizing the movement of goods for maximum efficiency and reliability.",
    icon: "ri-truck-line",
    href: "/logistics",
    image: "https://readdy.ai/api/search-image?query=Large%20modern%20warehouse%20logistics%20center%20with%20forklifts%20and%20organized%20pallet%20racks%2C%20efficient%20supply%20chain%20operations%2C%20clean%20industrial%20aesthetic%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20professional%20corporate%20photography%20style&width=800&height=600&seq=logistics-01&orientation=landscape",
  },
  {
    id: "freight-forwarding",
    title: "Freight Forwarding",
    description: "Efficient sea, air, and land freight solutions that ensure timely and secure cargo movement across borders.",
    icon: "ri-ship-2-line",
    href: "/freight-forwarding",
    image: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20busy%20international%20shipping%20port%20with%20container%20ships%20and%20cranes%2C%20global%20freight%20operations%2C%20organized%20container%20yards%2C%20golden%20hour%20lighting%2C%20cinematic%20wide%20angle%2C%20professional%20industrial%20photography&width=800&height=600&seq=freight-01&orientation=landscape",
  },
  {
    id: "clearing-forwarding",
    title: "Clearing & Forwarding",
    description: "Professional customs clearance, documentation, and compliance services that simplify international trade.",
    icon: "ri-file-list-3-line",
    href: "/clearing-forwarding",
    image: "https://readdy.ai/api/search-image?query=Modern%20customs%20brokerage%20office%20with%20digital%20screens%20showing%20trade%20data%2C%20professional%20team%20reviewing%20documents%2C%20clean%20corporate%20setting%2C%20warm%20interior%20lighting%2C%20premium%20business%20photography%2C%20minimalist%20design&width=800&height=600&seq=clearing-01&orientation=landscape",
  },
];

export const heroSlides = [
  {
    title: "Building Value.",
    subtitle: "Driving Growth.",
    description: "Your strategic partner for trading, procurement, freight forwarding, and supply chain solutions — connecting businesses with opportunities through reliable partnerships that drive sustainable growth.",
    image: "https://readdy.ai/api/search-image?query=Premium%20aerial%20photography%20of%20modern%20international%20shipping%20port%20at%20sunset%20with%20massive%20container%20ships%20docked%2C%20industrial%20cranes%20silhouetted%20against%20golden%20sky%2C%20global%20trade%20and%20logistics%20concept%2C%20cinematic%20wide%20angle%20shot%2C%20luxurious%20color%20grading%2C%20drone%20photography&width=1920&height=1080&seq=hero-01&orientation=landscape",
  },
];

export const aboutHighlights = [
  { number: "5+", label: "Years of Experience" },
  { number: "200+", label: "Global Partners" },
  { number: "30+", label: "Countries Served" },
  { number: "3,000+", label: "Successful Shipments" },
];

export const globalSourcingSteps = [
  {
    step: "01",
    title: "Understand",
    description: "We begin by understanding your business needs, project requirements, and operational objectives.",
  },
  {
    step: "02",
    title: "Source",
    description: "We identify trusted manufacturers and suppliers who meet the required quality, specifications, and budget.",
  },
  {
    step: "03",
    title: "Procure",
    description: "We manage procurement, negotiations, quality assurance, and order coordination with complete transparency.",
  },
  {
    step: "04",
    title: "Move",
    description: "Our logistics team coordinates freight forwarding, customs clearance, warehousing, and transportation.",
  },
  {
    step: "05",
    title: "Deliver",
    description: "Products are delivered safely, on time, and in accordance with your project schedule.",
  },
];

export const industries = [
  {
    id: "construction",
    title: "Construction & Infrastructure",
    description: "Reliable sourcing of construction materials, industrial equipment, and project logistics.",
    icon: "ri-building-2-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20construction%20site%20with%20heavy%20machinery%20and%20cranes%20against%20clear%20sky%2C%20large%20infrastructure%20development%20project%2C%20professional%20industrial%20photography%2C%20clean%20composition%2C%20warm%20natural%20lighting&width=800&height=600&seq=ind-construction&orientation=landscape",
  },
  {
    id: "healthcare",
    title: "Healthcare",
    description: "Supply of medical equipment, healthcare products, and dependable logistics for critical operations.",
    icon: "ri-heart-pulse-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20medical%20facility%20interior%20with%20advanced%20diagnostic%20equipment%2C%20clean%20hospital%20environment%2C%20professional%20healthcare%20setting%2C%20soft%20natural%20light%2C%20premium%20medical%20photography%2C%20minimalist%20aesthetic&width=800&height=600&seq=ind-healthcare&orientation=landscape",
  },
  {
    id: "manufacturing",
    title: "Manufacturing & Industrial",
    description: "Supporting production through strategic sourcing, industrial supplies, and efficient supply chain management.",
    icon: "ri-settings-3-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20industrial%20manufacturing%20facility%20with%20advanced%20machinery%20and%20production%20lines%2C%20clean%20factory%20floor%2C%20professional%20engineering%20environment%2C%20warm%20industrial%20lighting%2C%20premium%20corporate%20photography&width=800&height=600&seq=ind-manufacturing&orientation=landscape",
  },
  {
    id: "government",
    title: "Government & Public Sector",
    description: "Professional procurement and logistics solutions that meet institutional and regulatory requirements.",
    icon: "ri-government-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20government%20building%20architecture%20with%20professional%20corporate%20atmosphere%2C%20clean%20minimalist%20design%2C%20large%20glass%20windows%2C%20warm%20daylight%2C%20institutional%20setting%2C%20premium%20architectural%20photography&width=800&height=600&seq=ind-government&orientation=landscape",
  },
  {
    id: "ngos",
    title: "NGOs & Development Organizations",
    description: "Reliable sourcing and logistics support for humanitarian, development, and community impact projects.",
    icon: "ri-hand-heart-line",
    image: "https://readdy.ai/api/search-image?query=Humanitarian%20aid%20logistics%20and%20supply%20distribution%20in%20developing%20region%2C%20organized%20relief%20supplies%2C%20professional%20team%20coordinating%20operations%2C%20warm%20natural%20light%2C%20documentary%20style%20photography%2C%20authentic%20and%20hopeful%20atmosphere&width=800&height=600&seq=ind-ngos&orientation=landscape",
  },
  {
    id: "all-sectors",
    title: "Every Sector, Tailored Support",
    description: "Tailored procurement and logistics support designed to meet the unique operational needs of every client.",
    icon: "ri-briefcase-line",
    image: "https://readdy.ai/api/search-image?query=Diverse%20business%20professionals%20collaborating%20in%20modern%20corporate%20meeting%20room%2C%20varied%20industries%20represented%2C%20warm%20natural%20light%2C%20clean%20contemporary%20office%20environment%2C%20professional%20team%20photography%2C%20inclusive%20atmosphere&width=800&height=600&seq=ind-all&orientation=landscape",
  },
];

export const whyChooseUs = [
  {
    title: "Trusted Partnerships",
    description: "We build long-term relationships based on transparency, integrity, and mutual success.",
    icon: "ri-group-line",
  },
  {
    title: "Global Sourcing Network",
    description: "Access to reliable manufacturers and suppliers across international and local markets.",
    icon: "ri-global-line",
  },
  {
    title: "Efficient Execution",
    description: "From procurement to delivery, we manage every stage with precision and professionalism.",
    icon: "ri-rocket-line",
  },
  {
    title: "Quality Assurance",
    description: "Every product and solution is selected to meet the highest standards of quality and reliability.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Timely Delivery",
    description: "We understand that every project has deadlines, and we work tirelessly to deliver on time.",
    icon: "ri-timer-line",
  },
  {
    title: "Customer-Centric Solutions",
    description: "Every solution is tailored to meet the unique needs of each client and project.",
    icon: "ri-user-heart-line",
  },
];

export const testimonials = [
  {
    name: "James Ochieng",
    role: "CEO, East Africa Construction Group",
    content: "BEKAALI transformed our procurement strategy. Their supplier verification process saved us from a near-disastrous partnership, and the quality of machinery we now receive is consistently excellent.",
    company: "East Africa Construction Group",
    rating: 5,
  },
  {
    name: "Dr. Amina Hassan",
    role: "Procurement Director, Lake Region Hospital Network",
    content: "The medical equipment sourcing through BEKAALI has been exceptional. Their understanding of healthcare compliance requirements and attention to detail gives us complete confidence.",
    company: "Lake Region Hospital Network",
    rating: 5,
  },
  {
    name: "Peter Mwangi",
    role: "Managing Director, Kilimanjaro Imports Ltd",
    content: "Working with BEKAALI has streamlined our entire supply chain. Their logistics team handles everything from factory to warehouse — we simply focus on growing our business.",
    company: "Kilimanjaro Imports Ltd",
    rating: 5,
  },
  {
    name: "Sarah Wanjiku",
    role: "Supply Chain Manager, Green Valley Agro",
    content: "The agricultural equipment sourced through BEKAALI exceeded our expectations. Their technical knowledge of farming machinery and understanding of local conditions made all the difference.",
    company: "Green Valley Agro Ltd",
    rating: 5,
  },
];

export const latestNews = [
  {
    id: "news-1",
    title: "BEKAALI Expands Logistics Network with New Dar es Salaam Hub",
    excerpt: "Strategic expansion strengthens our East African logistics capabilities, reducing delivery times by 40% for Tanzanian and landlocked neighboring markets.",
    date: "2026-07-28",
    category: "Company News",
    image: "https://readdy.ai/api/search-image?query=Modern%20logistics%20hub%20and%20warehouse%20facility%20in%20African%20port%20city%2C%20new%20industrial%20development%2C%20clean%20modern%20architecture%2C%20professional%20corporate%20photography%2C%20warm%20natural%20lighting&width=800&height=600&seq=news-01&orientation=landscape",
  },
  {
    id: "news-2",
    title: "New Trade Agreement Opens Opportunities for East African Importers",
    excerpt: "Recent policy developments create favorable conditions for cross-border trade between China and East Africa — our analysis and what it means for your business.",
    date: "2026-07-15",
    category: "Industry Insight",
    image: "https://readdy.ai/api/search-image?query=Business%20professionals%20shaking%20hands%20in%20modern%20conference%20room%20with%20African%20and%20Chinese%20flags%2C%20international%20trade%20agreement%20signing%2C%20professional%20corporate%20setting%2C%20warm%20lighting%2C%20premium%20photography&width=800&height=600&seq=news-02&orientation=landscape",
  },
  {
    id: "news-3",
    title: "BEKAALI Partners with Leading Chinese Construction Equipment Manufacturer",
    excerpt: "Exclusive distribution partnership brings world-class heavy machinery to East African markets with full after-sales support and local technical training.",
    date: "2026-06-30",
    category: "Partnerships",
    image: "https://readdy.ai/api/search-image?query=Modern%20construction%20equipment%20showroom%20with%20heavy%20machinery%20displayed%2C%20professional%20industrial%20setting%2C%20clean%20environment%2C%20corporate%20atmosphere%2C%20warm%20lighting%2C%20premium%20photography&width=800&height=600&seq=news-03&orientation=landscape",
  },
];

export const contactInfo = {
  email: "info@bekaaliglobal.com",
  phone: "+254 715 815 521",
  whatsapp: "+86 130 2511 7490",
  address: "Cotts House, Moi Avenue, Majengo, Mvita, Mombasa, Kenya",
  officeHours: "Monday - Friday, 8:00 AM - 6:00 PM EAT",
};